import React from 'react';
import { bool, oneOf } from 'prop-types';
import { ProductAddonsTooltip } from '../../common/ProductAddOnsTooltip';

const SAMDualPathTooltip = ({ channel, checked }) => {

  const tooltipContent = (
    <div className="sui-w-64 sm:sui-w-72" data-channel={channel} data-component="SAMDualPathTooltip">
      <ul className="sui-list-disc sui-ml-4">
        <li>First, schedule your measure appointment online. We’ll
          come to your home to take precise digital measurements
          and make note of any special installation requirements.
        </li>
        <li>Based on these measurements and the specific flooring
          you choose, we’ll provide a project quote covering materials
          and installation.
        </li>
        <li>Once your purchase is complete, our local, licensed
          installers will contact you to schedule a convenient installation date.
        </li>
      </ul>
    </div>
  );

  return (
    <ProductAddonsTooltip checked={checked} tooltipContent={tooltipContent} title="HOW IT WORKS" />
  );
};

SAMDualPathTooltip.displayName = 'ProductAddOns-SAM-dualPath-tooltip';

SAMDualPathTooltip.propTypes = {
  /** What view to render ['desktop' || 'mobile']  */
  channel: oneOf(['desktop', 'mobile']),
  /** Whether or not the checkbox is checked */
  checked: bool
};

SAMDualPathTooltip.defaultProps = {
  channel: 'desktop',
  checked: false
};

export { SAMDualPathTooltip };